import { BusEvent } from '@web/common';
import { Guid } from '@web/utils';

export class WarehouseOrderPreviewBusEvent extends BusEvent {
  public constructor(
    private readonly data: {
      orderId: Guid;
    },
  ) {
    super();
  }

  public get orderId(): Guid {
    return this.data.orderId;
  }
}
